import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Helmet } from 'react-helmet'
import isEmpty from 'lodash/isEmpty'

import { trackGAEvent } from '../utilities/tracking'
import { getPlant, resetClassifyImage, setFavoritePlant, addPlantToSensor, getUserProfile } from '../../actions'
import { SENSOR_DEVICE } from '../../constants/routes'

import { FillerDiv, CenteredDiv } from '../StyledComponents/Fillers'
import {
    SliderContainer,
    ImageSlider,
    PlantDetailsImage,
    PlantDetailsImageShadow,
    PlantDetailsHeader,
    PlantName,
    PlantLatinName,
    PlantActionsContainer,
    PlantActionsButton
} from '../StyledComponents/Plants/PlantDetails'
import PlantTabContainer from '../Plant/PlantTabContainer'
import LoadingSpinner from '../Global/LoadingSpinner'
import FABButton from '../Global/FABButton'
import LoadingOverlay from '../Global/LoadingOverlay'

class PlantDetailsPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loadAddToSensor: false,
            entryTime: +new Date(),
        }

        this.addPlantToSensor = this.addPlantToSensor.bind(this)
        this.setAsFavorite = this.setAsFavorite.bind(this)
    }

    componentDidMount() {
        const { sessionState, getProfile, match } = this.props

        window.scrollTo(0, 0)
        this.props.getPlant(match.params.id)

        if (!!sessionState && !!sessionState.idToken && !sessionState.gardenKnowledge) {
            const { token } = sessionState.idToken
            getProfile(sessionState.authUser.uid, token)
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            devices, sessionState, match: nextMatch, plants,
        } = nextProps
        const { mode, match, history } = this.props
        const { loadAddToSensor } = this.state
        const { sensorId } = mode.data

        if (match.params.id !== nextMatch.params.id && !plants[nextMatch.params.id]) {
            this.props.getPlant(nextMatch.params.id)
            window.scrollTo(0, 0)
        }

        if (loadAddToSensor && !!sensorId && !!devices[sensorId]) {
            if (!!sessionState.authUser && !!sessionState.idToken) {
                const plantId = match.params.id
                if (devices[sensorId].plants.includes(plantId)) {
                    this.setState({ loadAddToSensor: false })
                    history.push(SENSOR_DEVICE.replace(':uuid', sensorId))
                }
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { sessionState, getProfile } = this.props
        if (!prevProps.sessionState.idToken && !!sessionState.idToken
            && !sessionState.gardenKnowledge) {
            const { token } = sessionState.idToken
            getProfile(sessionState.authUser.uid, token)
        }
    }

    componentWillUnmount() {
        const { entryTime } = this.state
        const { sessionState } = this.props

        if (entryTime) {
            const duration = parseInt((+new Date() - entryTime) / 1000, 10)

            trackGAEvent('interaction', {
                interaction_value: duration,
                interaction_category: 'Plant-Details',
                interaction_action: 'leave-page',
                interaction_label: `${sessionState.gardenKnowledge || 'NOT_SPECIFIED'}`,
            })
        }

        this.props.resetClassifyImage()
    }

    setAsFavorite() {
        const {
            setAsFavorite, match, sessionState,
        } = this.props

        const plantId = match.params.id

        if (sessionState.authUser.uid && !!sessionState.idToken && plantId) {
            setAsFavorite(
                plantId,
                false,
                sessionState.authUser.uid,
                sessionState.idToken.token
            )
        }
    }

    addPlantToSensor() {
        const {
            mode, addToSensor, sessionState, match, devices,
        } = this.props

        if (mode.mode === 'add-plant') {
            const { sensorId } = mode.data
            if (!!sessionState.authUser && !!sessionState.idToken && sensorId) {
                const plantId = match.params.id
                addToSensor(
                    sessionState.authUser.uid,
                    sessionState.idToken.token,
                    sensorId,
                    plantId,
                    devices[sensorId].plants.length,
                )
                this.setState({ loadAddToSensor: true })
            }
        }
    }

    render() {
        const {
            plants, match, classifier, mode, sessionState,
        } = this.props

        const plant = plants ? plants[match.params.id] : null

        if (!plant) {
            return <CenteredDiv><LoadingSpinner /></CenteredDiv>
        }

        const sliderSettings = {
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        }

        const showActions = false
        const plantActions = showActions ? (
            <PlantActionsContainer>
                <PlantActionsButton color="info">Add to sensor</PlantActionsButton>
                <PlantActionsButton color="info">Is not this plant</PlantActionsButton>
            </PlantActionsContainer>
        ) : null

        const classifierImage = classifier && classifier.image
            ? <PlantDetailsImage imageWidth={window.innerWidth} src={classifier.image} />
            : null

        const plantImage = isEmpty(plant.image)
            ? null
            : <PlantDetailsImage imageWidth={window.innerWidth} src={plant.image} />

        const fabItems = mode.mode === 'add-plant' ? ['favorite', 'sensorAdd'] : ['favorite']
        const fabButton = sessionState.authUser ? (
            <FABButton
                items={fabItems}
                onFavoriteClicked={this.setAsFavorite}
                onAddSensorClicked={this.addPlantToSensor}
            />
        ) : null

        const loadingOverlay = this.state.loadAddToSensor
            ? <LoadingOverlay />
            : null

        return (
            <FillerDiv>
                <Helmet>
                    <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
                    <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
                </Helmet>
                {loadingOverlay}
                <SliderContainer>
                    <ImageSlider {...sliderSettings}>
                        {plantImage}
                        {classifierImage}
                    </ImageSlider>
                    <PlantDetailsImageShadow />
                </SliderContainer>
                <PlantDetailsHeader>
                    <PlantName>{plant.localized_name}</PlantName>
                    <PlantLatinName>{plant.name}</PlantLatinName>
                    {plantActions}
                    <PlantTabContainer plant={plant} />
                </PlantDetailsHeader>
                {fabButton}
            </FillerDiv>
        )
    }
}

const mapStateToProps = state => ({
    plants: state.plants,
    classifier: state.classifier,
    mode: state.mode,
    sessionState: state.sessionState,
    devices: state.devices,
})

export default compose(
    withRouter,
    connect(mapStateToProps, {
        getPlant,
        resetClassifyImage,
        setAsFavorite: setFavoritePlant,
        addToSensor: addPlantToSensor,
        getProfile: getUserProfile,
    })
)(PlantDetailsPage)



// WEBPACK FOOTER //
// ./src/components/pages/PlantDetails.js